// most mobile phones
const mobileBreakpointRaw = 840;
const mobileBreakpoint = `${mobileBreakpointRaw}px`;
const mobileHeightBreakpointRaw = 500;
const mobileHeightBreakpoint = `${mobileHeightBreakpointRaw}px`;

// older phones e.g. iPhone 5 / SE
const mobileBreakpointSmRaw = 600;
const mobileBreakpointSm = `${mobileBreakpointSmRaw}px`;

export {
  mobileBreakpoint,
  mobileBreakpointRaw,
  mobileBreakpointSm,
  mobileBreakpointSmRaw,
  mobileHeightBreakpointRaw,
  mobileHeightBreakpoint,
};
